import apiSlice from "./ApiSlice";

export const inquiryLabelApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    //GET ALL Inquiry Label
    getAllInquiryLabel: builder.query({
        providesTags: ["inquryLabel"],
      query: () => {
        return {
          url: "/inquiry-label",
          method: "GET",
        };
      },
    }),

    // ADD
    addInquiryLabel: builder.mutation({
      invalidatesTags: ["inquryLabel"],
      query: (body) => {
        return {
          url: "/inquiry-label/add",
          method: "POST",
          body,
        };
      },
    }),
    // Get inquryLabel Filter Pagination
    getInquiryLabelPagination: builder.query({
      providesTags: ["inquryLabel"],
      query: (body) => {
        return {
          url: "/inquiry-label/",
          method: "POST",
          body,
        };
      },
    }),
    // Single ID Edit Data
    singleEditData: builder.query({
      providesTags: ["inquryLabel"],
      query: (id) => {
        return {
          url: `/inquiry-label/${id}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),
    //Edit
    editInquiryLabel: builder.mutation({
      invalidatesTags: ["inquryLabel"],
      query: ({ body, id }: any) => {
        return {
          url: `/inquiry-label/${id}`,
          method: "PUT",
          body,
        };
      },
    }),

    // Delete Data
    deleteInquiryLabel: builder.mutation({
      invalidatesTags: ["inquryLabel"],
      query: (id) => {
        return {
          url: `/inquiry-label/${id}`,
          method: "DELETE",
        };
      },
    }),
  }),
});

export const {
  useAddInquiryLabelMutation,
  useGetInquiryLabelPaginationQuery,
  useEditInquiryLabelMutation,
  useDeleteInquiryLabelMutation,
  useSingleEditDataQuery,
  useGetAllInquiryLabelQuery
} = inquiryLabelApi;
